// extracted by mini-css-extract-plugin
module.exports = {"VerticalLine":"VerticalLine_VerticalLine__3qp4Z"};